/*eslint-disable*/

import React, { useEffect, useState } from "react";
import logo from "../../Assets/images/logo.png";
import logoDark from "../../Assets/images/logoDark.png";
import { Link, useNavigate } from "react-router-dom";
// import { FiUser } from 'react-icons/fi';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUserData,
  selectSignedIn,
  logout,
  setUserData,
} from "../../Redux/UserSlice";
// import { AiOutlinePlus } from 'react-icons/ai';
// import Alert from 'react-bootstrap/Alert';
// import Button from 'react-bootstrap/Button';
import Offcanvas from "react-bootstrap/Offcanvas";
// import { FaToggleOff } from 'react-icons/fa';
// import DropdownToggle from 'react-bootstrap/esm/DropdownToggle';
import HeaderModal from "../Modal/HeaderModal";
import { api_url } from "../../Constants/web_services";

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize navigate
  const isSignedIn = useSelector(selectSignedIn);
  const userData = useSelector(selectUserData);
  const [toggle, setToggle] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  // const [setShow] = useState(false);
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleLogout = (dispatch, navigate) => {
    dispatch(logout({ userData: null, isSignedIn: false }));

    navigate("/");
  };

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const path = location.pathname;
  const arr = path.split("/");
  const firstPart = arr[1];

  const fetchUserData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(api_url + `/api/me`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        // console.log('data====', data)
        // Update the user data in Redux store
        dispatch(setUserData(data?.data));
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };


  useEffect(() => {
    // console.log(userData)
    // Fetch the latest user data when the component mounts
    fetchUserData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 2) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <header
        style={{ zIndex: 99999 }}
        className="site-header w-100 header-style-1 mobile-sider-drawer-menu header-full-width"
      >
        <div className="sticky-wrapper" style={{ height: 90 }}>
          <div
            className={`sticky-header main-bar-wraper navbar-expand-lg is-fixed ${!isScrolled &&
              location.pathname !== "/search" &&
              firstPart !== "company" &&
              location.pathname !== "/user-profile/:id" &&
              location.pathname !== "/user-profile/my-orders" &&
              location.pathname !== "/user-profile/order-details" &&
              location.pathname.indexOf("forgotpassword") === -1
              ? ""
              : "color-fill"
              }`}
          >
            <div
              className={`sticky-header main-bar-wraper  navbar-expand-lg 
                        ${location.pathname !== "/" &&
                  location.pathname !== "/contact-us" &&
                  location.pathname !== "/about-us" &&
                  location.pathname !== "/jobs" &&
                  location.pathname.indexOf("forgotpassword") === -1
                  ? "color-fill "
                  : ""
                } `}
            >
              <div
                className={`main-bar ${!isScrolled &&
                  location.pathname !== "/search" &&
                  firstPart !== "company" &&
                  location.pathname !== "/user-profile/:id" &&
                  location.pathname !== "/user-profile/my-orders" &&
                  location.pathname !== "/user-profile/order-details" &&
                  location.pathname.indexOf("forgotpassword") === -1
                  ? ""
                  : "shadow"
                  }`}
              >
                <div className="container clearfix">
                  {/*Logo section start*/}
                  <div className="logo-header">
                    <div className="logo-header-inner logo-header-one home-header">
                      <Link to={"/"}>
                        <img
                          src={logoDark}
                          alt=""
                          style={{ width: "150px" }}
                          className="site-logo-has"
                        />
                        <img
                          src={logo}
                          alt=""
                          style={{ width: "120px" }}
                          className="site-logo-sticky"
                        />
                      </Link>
                    </div>
                  </div>
                  {/*Logo section End*/}
                  {/* NAV Toggle Button */}
                  <button
                    id="mobile-side-drawer"
                    data-target=".header-nav"
                    data-toggle="collapse"
                    type="button"
                    className="navbar-toggler collapsed"
                    onClick={() => setToggle(true)}
                  >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar icon-bar-first" />
                    <span className="icon-bar icon-bar-two" />
                    <span className="icon-bar icon-bar-three" />
                  </button>

                  {/* MAIN Vav */}
                  <div className="nav-animation header-nav navbar-collapse collapse d-flex justify-content-start me-auto">
                    <ul className=" nav navbar-nav">
                      <li
                        className={`${location.pathname === "/"
                          ? "has-child current-menu-item "
                          : ""
                          } `}
                      >
                        <Link className="text-decoration-none" to={"/"}>
                          Home
                        </Link>
                        {/* <ul className="sub-menu">
                      <li>
                        <Link className='text-decoration-none' to="index.html">Home 1</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="index-2.html">Home 2</Link>
                      </li>
                    </ul> */}
                      </li>
                      <li
                        className={`${location.pathname === "/about-us"
                          ? "has-child current-menu-item "
                          : ""
                          } has-child`}
                      >
                        <Link className="text-decoration-none" to="/about-us">
                          About us
                        </Link>
                        {/* <ul className="sub-menu">
                      <li>
                        <Link className='text-decoration-none' to="/about-us">About us</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="javascript:;">Categories</Link>
                        <ul className="sub-menu">
                          <li>
                            <Link className='text-decoration-none' to="all-categories.html">All Categories</Link>
                          </li>
                          <li>
                            <Link className='text-decoration-none' to="categories-detail.html">Categories Detail</Link>
                          </li>
                          <li>
                            <Link className='text-decoration-none' to="categories-detail-2.html">Categories Detail 2</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="javascript:;">Search</Link>
                        <ul className="sub-menu">
                          <li>
                            <Link className='text-decoration-none' to="search-list.html">Search List</Link>
                          </li>
                          <li>
                            <Link className='text-decoration-none' to="new-search-list-2.html">Search List 2</Link>
                          </li>
                          <li>
                            <Link className='text-decoration-none' to="search-list-map.html">Search List Map</Link>
                          </li>
                          <li>
                            <Link className='text-decoration-none' to="search-list-map2.html">Search List Map 2</Link>
                          </li>
                          <li>
                            <Link className='text-decoration-none' to="search-grid.html">Search-grid</Link>
                          </li>
                          <li>
                            <Link className='text-decoration-none' to="search-grids-map.html">Search-grid-map</Link>
                          </li>
                          <li>
                            <Link className='text-decoration-none' to="search-grid-map2.html">Search-grid-map2</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="error-404.html">Error 404</Link>
                      </li>
                    </ul> */}
                      </li>
                      {/* <li className="has-child">
                    <Link className='text-decoration-none' to="javascript:;">Profile</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link className='text-decoration-none' to="profile-full.html">Profile</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="profile-sidebar.html">Profile Sidebar</Link>
                      </li>
                    </ul>
                  </li> */}
                      {/* <li className="has-child">
                    <Link className='text-decoration-none' to="javascript:;">Jobs</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link className='text-decoration-none' to="job-listing.html">Job listing</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="job-grid.html">Job grid</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="job-detail.html">Job detail</Link>
                      </li>
                    </ul>
                  </li> */}
                      {/* <li className="has-child">
                    <Link className='text-decoration-none' to="javascript:;">Blog</Link>
                    <ul className="sub-menu">
                      <li>
                        <Link className='text-decoration-none' to="blog-grid.html">Blog Grid</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="blog-grid-2.html">Blog Grid 2</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="blog-list.html">Blog list</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="blog-list-2.html">Blog list 2</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="blog-list-3.html">Blog list 3</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="blog-list-4.html">Blog list 4</Link>
                      </li>
                      <li>
                        <Link className='text-decoration-none' to="blog-detail.html">Blog detail</Link>
                      </li>
                    </ul>
                  </li> */}
                      <li
                        className={`${location.pathname === "/contact-us"
                          ? "has-child current-menu-item "
                          : ""
                          } has-child`}
                      >
                        <Link
                          className="text-decoration-none"
                          to={"/contact-us"}
                        >
                          Contact
                        </Link>
                      </li>

                      <li
                        className={`${location.pathname === "/jobs"
                          ? "has-child current-menu-item "
                          : ""
                          } has-child`}
                      >
                        <Link
                          className="text-decoration-none"
                          to={"/jobs"}
                        >
                          Jobs
                        </Link>
                      </li>
                      {isSignedIn ? (
                        <>
                          <li
                            className={`${location.pathname === "/user-profile/:id" ||
                              location.pathname === "/user-profile/my-orders"
                              ? "has-child current-menu-item "
                              : ""
                              } has-child`}
                          >
                            <Link
                              className="text-decoration-none"
                              to={`/user-profile/${userData?.id}`}
                            >
                              User Panel
                            </Link>
                          </li>
                        </>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </div>
                  {/* Header Right Section*/}
                  <div className="extra-nav msdateuser/-auto header-2-nav">
                    <div className="extra-cell">
                      {/*Login*/}
                      {isSignedIn ? (
                        <>
                          <Link
                            to={`/user-profile/${userData?.id}`}
                            className="site-button aon-btn-login"
                          >
                            <span className="login-image btn-height-fix">
                              <img
                                src={api_url + "/" + userData?.image}
                                style={{ width: 30 }}
                                alt=""
                              />
                              {userData?.username}
                            </span>
                          </Link>

                          <button
                            type="button"
                            className="site-button aon-btn-login btn-height-fix"
                            onClick={() => handleLogout(dispatch, navigate)}
                          >
                            <i className="fa-solid fa-sign-out-alt"></i>
                            Logout
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="site-button aon-btn-login"
                            data-toggle="modal"
                            data-target="#login-signup-model"
                            onClick={() => setModalShow(true)}
                          >
                            <i className="fa-solid fa-arrows-split-up-and-left"></i>
                            Login / SignUp
                          </button>
                        </>
                      )}

                      <HeaderModal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Off convas start here */}

      <Offcanvas
        className=""
        show={toggle}
        onHide={() => setToggle(!toggle)}
        restoreFocus={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="logo-header">
              <div className="logo-header-inner logo-header-one">
                <Link to={"/"}>
                  <img src={logoDark} alt="" className="site-logo-has" />
                  <img src={logoDark} alt="" className="site-logo-sticky" />
                </Link>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="px-0">
          <ul className=" nav navbar-nav">
            <li
              onClick={() => setToggle(false)}
              className={`${location.pathname === "/"
                ? "has-child current-menu-item border-bottom border-1 py-2 px-3"
                : "border-bottom border-1 py-2 px-3"
                } `}
            >
              <Link
                className="text-decoration-none text-dark py-3"
                data-bs-dismiss="offcanvas"
                to={"/"}
              >
                Home
              </Link>
            </li>
            <li
              onClick={() => setToggle(false)}
              className={`${location.pathname === "/about-us"
                ? "has-child current-menu-item  border-bottom border-1 py-2 px-3"
                : "border-bottom border-1 py-2 px-3"
                } has-child`}
            >
              <Link
                className="text-decoration-none text-dark py-3"
                to="/about-us"
              >
                About us
              </Link>
            </li>
            <li
              onClick={() => setToggle(false)}
              className={`${location.pathname === "/contact-us"
                ? "has-child current-menu-item  border-bottom border-1 py-2 px-3"
                : "border-bottom border-1 py-2 px-3"
                } has-child`}
            >
              <Link
                className="text-decoration-none text-dark py-3"
                to={"/contact-us"}
              >
                Contact
              </Link>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Off convas end */}
    </>
  );
}

export default Header;
